<template>
  <div class="fee-item-info clearfix" :class="{ client: currentUserIsClient }">
    <div v-if="currentUserIsClient" class="fee-item-select">
      <div v-if="paymentsStatus.paymentsAreLoading" class="round-choice-transparent">
        <span class="content-title fas fa-lg fa-spinner fa-spin" />
      </div>
      <template v-else>
        <div v-if="!paymentsStatus.somePaymentsArePending || paymentsStatus.somePaymentsAreNotPending" class="round-choice-content">
          <input
            :id="`checkbox-${relatedPaymentId}`"
            :value="`${relatedPaymentId}`"
            type="checkbox"
            class="input-choice"
            :checked="paymentsStatus.selectablePayments.length === 0"
            :disabled="disabled"
            @change="$emit('change', {
              checked: $event.target.checked,
              selection: paymentsStatus.selectablePayments.length !== 0
                ? paymentsStatus.selectablePayments
                : paymentsStatus.unselectablePayments
            })">
          <label
            :for="`checkbox-${relatedPaymentId}`"
            class="label-choice transition-fast" />
        </div>
        <div v-else>
          <b-tooltip type="is-white" label="Pago en revisión">
            <div class="round-choice-content payment-is-pending">
              <input
                type="checkbox"
                class="input-choice"
                :checked="true"
                :disabled="true">
              <label class="label-choice transition-fast" />
            </div>
          </b-tooltip>
        </div>
      </template>
    </div>
    <div class="fee-item-resume-content">
      <div class="type-content">
        <b-tooltip
          :label="'Crédito hipotecario y consumo'"
          size="is-small"
          type="is-white"
          multilined>
          <span>🏡 +💰</span>
        </b-tooltip>
      </div>
      <div class="price-content">
        <div v-if="!disabled && !paymentsStatus.anyPaymentsInPaymentsMap && paymentsStatus.somePaymentsAreNotPending" class="show-fee-label big-size-text">
          <label
            :for="`checkbox-${relatedPaymentId}`"
            class="is-clickable content-title">
            <span>Ver cuota</span>
          </label>
        </div>
        <div v-else-if="paymentsStatus.anyPaymentsInPaymentsMap || paymentsStatus.somePaymentsArePending" class="big-size-text">
          <span
            :id="`${relatedPaymentId}-amount`"
            class="content-title">
            $ {{
              formatNumber(
                (paymentsStatus.selectablePayments.length === 0 && paymentsStatus.unselectablePayments.length === 0)
                  ? paymentsStatus.totalTransactionPaymentsAmount
                  : paymentsStatus.totalAmount)
            }}
          </span>
        </div>
        <div v-else />
      </div>
      <div class="duration-content med-size-text">
        <div>
          <span class="content-title">Cuota:</span>
          <span class="content-value">{{ payments[0].paymentNumber }}</span>
        </div>
        <div>
          <span :class="payments[0].lateDays > 0 ? 'alert-content-title' : 'content-title'">
            {{ payments[0].lateDays > 0 ? 'Venció:' : 'Vence:' }}
          </span>
          <span class="content-value">{{ dateToClientFormat(payments[0].dueDate) }}</span>
        </div>
      </div>
      <div v-if="!currentUserIsClient" class="late-days-content med-size-text">
        <b-tooltip label="Días de mora" type="is-white">
          <div
            class="tag med-size-text is-danger"
            :class="
              payments[0].lateDays >= 90 ? 'ninety-days' :
              payments[0].lateDays >= 60 ? 'sixty-days' :
              payments[0].lateDays >= 30 ? 'thirty-days' :
              payments[0].lateDays >= 11 ? 'less-than-thirty-days' : 'healthy-days'
            ">
            {{ payments[0].lateDays }}
          </div>
        </b-tooltip>
      </div>
    </div>
    <div v-if="paymentsStatus.anyPaymentsInPaymentsMap || paymentsStatus.somePaymentsArePending" class="details-content">
      <a :id="`extend-${relatedPaymentId}`" href="#" @click.prevent="$emit('extend-payment')">
        <span class="fa" :class="globalExtendedPayment === relatedPaymentId ? 'fa-minus-circle' : 'fa-plus-circle'" />
      </a>
    </div>
  </div>
</template>

<script>
import { formatNumber } from '@/infrastructure/format';
// import { dateToFormatedString } from '@/infrastructure/date';
import { dateToClientFormat } from '@/infrastructure/date';

export default {
  props: {
    currentUserIsClient: { type: Boolean, default: false },
    paymentsStatus: { type: Object, default: () => ({}) },
    payments: { type: Array, default: () => [] },
    relatedPaymentId: { type: String, default: '' },
    globalExtendedPayment: { type: String, default: '' },
    paymentIndex: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {};
  },
  methods: {
    formatNumber: number => formatNumber({ number }),
    dateToClientFormat: date => dateToClientFormat(date)
  }
};
</script>

<style scoped>
.card-item {
  overflow: unset;
}
.big-size-text {
  font-size: 1.2rem;
}
.med-size-text {
  font-size: 0.9rem;
}
.small-size-text {
  font-size: 0.75rem;
}
/* .noDoubleShadow {
  box-shadow: none;
} */
.tag {
  margin-left: 3px;
}
.tag.ninety-days {
  background-color: var(--secondary-dark);
}
.tag.sixty-days {
  background-color: var(--secondary);
}
.tag.thirty-days {
  background-color: orangered;
}
.tag.less-than-thirty-days {
  background-color: var(--yellow);
}
.tag.healthy-days {
  background-color: var(--primary);
}

.content-title {
  color: var(--primary);
  font-weight: 600;
}
.fee-item-info {
  display: grid;
  grid-template-columns: minmax(auto, 1fr) 2rem;
  gap: 0% 5%;
  place-items: center;
  place-content: center stretch;
  padding: 1rem;
}
.fee-item-info.client {
  grid-template-columns: minmax(auto, 1.7rem) minmax(auto, 1fr) minmax(auto, 1.5rem);
}

.round-choice-transparent {
  border: 2px solid transparent;
}
.round-choice-content.payment-is-pending {
  border: 2px solid var(--yellow);
}
.round-choice-content.payment-is-pending input.input-choice:disabled ~ label.label-choice::before {
  background-color: var(--yellow);
}

.fee-item-info .fee-item-resume-content {
  width: 100%;
  display: grid;
  grid:
    "info1 info2 info3 info4" auto
    / 4rem minmax(max-content, 1fr) minmax(auto, 1.5fr) minmax(auto, 0.5fr);
  gap: 0% 5%;
  place-items: center;
  place-content: center stretch;
}
.client .fee-item-resume-content {
  grid:
    "info1 info2 info3" auto
    / 5rem minmax(max-content, 1fr) minmax(auto, 1.5fr);
}
.fee-item-info .fee-item-resume-content .type-content { grid-area: info1; }
.fee-item-info .fee-item-resume-content .price-content { grid-area: info2; }
.fee-item-info .fee-item-resume-content .duration-content { grid-area: info3; }
.fee-item-info .fee-item-resume-content .late-days-content { grid-area: info4; }

.content-title {
  color: var(--primary);
  font-weight: 600;
}
.alert-content-title {
  color: var(--secondary);
  font-weight: 600;
}

.fee-item-resume-content .price-content .show-fee-label {
  border-radius: 1rem;;
  padding: 0.5rem 1rem;
  background: #F2FBFB;
}

.fee-item-info .duration-content .fa-exclamation-triangle,
table .significant-data {
  color: var(--secondary);
}

.fa-exclamation-triangle {
  margin-right: 0.5rem;
}

.fee-item-resume-content .duration-content {
  display: flex;
  flex-flow: column wrap;
  justify-content: space-evenly;
  align-items: center;
}
.fee-item-info .details-content,
.fee-item-resume-content .duration-content div {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
}

.fee-item-resume-content .duration-content div span {
  margin-right: 0.3rem;
}

@media (max-width: 1000px) {
  .big-size-text {
    font-size: 1rem;
  }

  .med-size-text {
    font-size: 0.75rem;
  }

  .small-size-text {
    font-size: 0.65rem;
  }
}

@media (max-width: 900px) {
  .big-size-text {
    font-size: 1.2rem;
  }

  .med-size-text {
    font-size: 0.9rem;
  }

  .small-size-text {
    font-size: 0.75rem;
  }

  .duration-content .content-title,
  .duration-content .content-value {
    display: inline-block;
  }
}
@media (max-width: 782px) {
  .mobile-field {
    width: 100%;
    flex-grow: 1;
    margin-right: 0 !important;
  }
    .card-item .fee-item-details {
    grid:
      "header header" auto
      "col1 col2" auto
      "footer footer" auto
      / 1.3fr 1fr;
  }
}
@media (max-width: 660px) {
  .fee-item-info .fee-item-resume-content {
    grid:
      "info1" auto
      "info2" auto
      "info3" auto
      "info4" auto
      / 1fr;
    place-items: center;
  }
  .client .fee-item-resume-content {
    grid:
      "info1" auto
      "info2" auto
      "info3" auto
      /1fr;
    place-items: center;
  }
  .card-item .fee-item-details {
    grid:
      "header" auto
      "col1" auto
      "col2" auto
      "footer" auto
      / 1fr;
    gap: 0.5rem 0rem;
  }
}

@media (max-width: 480px) {
  .fee-item-info {
    border-radius: 1.5rem;
  }
}

@media (max-width: 380px) {
  .big-size-text {
    font-size: 1rem;
  }

  .med-size-text {
    font-size: 0.75rem;
  }

  .small-size-text {
    font-size: 0.65rem;
  }
}
</style>
